module.exports = __webpack_public_path__ + "img/14_21.6152163a.png";